import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";

const DeleteProjectModal = ({
    show,
    handleClose,
    recordObject,
    fetchRecords,
    endpoint,
    record_type,
    message,
}) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const [error, setError] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("");
    const [checkboxes, setCheckboxes] = useState([false, false, false, false, false, false]);
    const [loadingDel, setLoadingDel] = useState(false);
    const [recordId, setRecordId] = useState("");

    // ✅ Update record ID when recordObject changes
    useEffect(() => {
        if (recordObject) {
            setRecordId(recordObject._id || "");
        }
    }, [recordObject]);

    // ✅ Handle individual checkbox change
    const handleCheckboxChange = (index) => {
        const updated = [...checkboxes];
        updated[index] = !updated[index];
        setCheckboxes(updated);
    };

    // ✅ Handle "Accept All" checkbox
    const handleAcceptAllChange = (e) => {
        const checked = e.target.checked;
        setCheckboxes(checkboxes.map(() => checked));
    };

    // ✅ Handle text input changes
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    // ✅ Validation conditions
    const allChecked = checkboxes.every(Boolean);
    const isInputCorrect = inputValue === record_type;
    const isButtonDisabled = !(allChecked && isInputCorrect);

    // ✅ Close modal and reset
    const handleCloseModal = () => {
        setRecordId("");
        setCheckboxes([false, false, false, false, false, false]);
        setInputValue("");
        setError({ message: "", display: false });
        handleClose();
    };

    // ✅ Delete request
    const deleteOrganization = async () => {
        try {
            setLoadingDel(true);
            const response = await fetch(`https://backend.erioon.com/${endpoint}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id: user_id, record_id: recordId }),
            });
            setLoadingDel(false);

            if (response.ok) {
                handleCloseModal();
                fetchRecords();
            } else {
                setError({ message: t.err_delete_general, display: true });
            }
        } catch (err) {
            setLoadingDel(false);
            setError({ message: t.err_delete_general, display: true });
        }
    };

    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>Do you want to delete this project?</p>
                {/* <i className="fa-solid fa-x" onClick={handleCloseModal}></i> */}
            </div>

            <div className="modal_body">
                <p className="warning_delete_message">{message} You must accept all conditions to confirm this deletion.</p>

                {/* ✅ Confirmation checklist */}
                <div className="confirm_delete_resources_cont">
                    <div className="confirm_delete_resources_item accept_all">
                        <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleAcceptAllChange}
                        />
                        <p><strong>Accept all conditions below</strong></p>
                    </div>
                    {[
                        "The project’s code environment will be permanently removed, and any hosted web apps, APIs, or services will be stopped.",
                        "All databases associated with this project will be permanently deleted.",
                        "All active deployments linked to this project will be removed.",
                        "All access accounts and permissions associated with this project will be revoked.",
                        "All API keys generated for this project will be deleted.",
                        "All network and configuration settings tied to this project will be cleared.",
                    ].map((text, index) => (
                        <div key={index} className="confirm_delete_resources_item">
                            <input
                                type="checkbox"
                                checked={checkboxes[index]}
                                onChange={() => handleCheckboxChange(index)}
                            />
                            <p>{text}</p>
                        </div>
                    ))}


                </div>

                <div className="delete_action_cont">
                    <p className="type_phrase_delete">
                        {t.delete_modal.confirm_del_mex} <strong>{record_type}</strong>
                    </p>
                    <input
                        className="delete_input"
                        placeholder={record_type}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`delete_btn ${!isButtonDisabled ? "delete_btn_active" : ""}`}
                        onClick={deleteOrganization}
                        disabled={isButtonDisabled}
                    >
                        {loadingDel ? <Spinner loading={loadingDel} /> : <>{t.delete}</>}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteProjectModal;
